export const DashboardConstants = {
    CHANGE_PAGE: "CHANGE_PAGE", 
    CHANGE_TOTAL_NUMBER_OF_PAGES: "CHANGE_TOTAL_NUMBER_OF_PAGES", 
    CHANGE_TOTAL_SLIDES: "CHANGE_TOTAL_SLIDES",
    CLOSE_DRAWER: "CLOSE_DRAWER", 
    OPEN_DRAWER: "OPEN_DRAWER", 
    INIT_TAGS: "INIT_TAGS", 
    ADD_TAG: "ADD_TAG",
    ADD_TO_POLLER: "ADD_TO_POLLER",
    REMOVE_FROM_POLLER: "REMOVE_FROM_POLLER",
    UPDATE_ANALYSIS_KEYS: "UPDATE_ANALYSIS_KEYS",
    SET_ANALYSIS_FILTER_BOOL: "SET_ANALYSIS_FILTER_BOOL",
    CLEAR_AND_ADD_TO_POLLER: "CLEAR_AND_ADD_TO_POLLER",
    CLEAR_POLLER: "CLEAR_POLLER",
}


